import { render, staticRenderFns } from "./CoolingChamberTemperature.vue?vue&type=template&id=136a1bd4"
import script from "./CoolingChamberTemperature.vue?vue&type=script&lang=js"
export * from "./CoolingChamberTemperature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports